import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './NotFound.module.css';

const CATEGORIES = [
  { id: 'casas', name: 'Casas', icon: 'fas fa-home' },
  { id: 'apartamentos', name: 'Apartamentos', icon: 'fas fa-building' },
  { id: 'lotes', name: 'Lotes e Terrenos', icon: 'fas fa-mountain' },
  { id: 'lojas', name: 'Comercial', icon: 'fas fa-store' },
];

const NotFound: React.FC = () => {
  const [propertyCode, setPropertyCode] = useState('');

  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (propertyCode.trim()) {
      window.location.href = `/imovel/${propertyCode}`;
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100" style={{ overflowX: "hidden" }}>
      <Header />

      <main className="flex-grow-1 d-flex align-items-center py-4 py-md-5">
        <div className="container">
          <div className="row align-items-center g-5 flex-column-reverse flex-lg-row">
            <div className="col-12 col-lg-6 text-start">
              <span className="badge text-primary bg-primary bg-opacity-10 px-3 py-2 mb-3 fw-bold small">
                <i className="fas fa-exclamation-circle me-1"></i> ERRO 404
              </span>

              <h1 className="display-5 fw-bold mb-3 d-none d-md-block" style={{ color: '#0B2545' }}>
                Ops! Esta casa já <span className="text-white px-2 py-1 rounded-1" style={{ backgroundColor: '#0B2545' }}>encontrou</span> um dono.
              </h1>
              <h1 className="display-6 fw-bold mb-3 d-block d-md-none" style={{ color: '#0B2545' }}>
                Ops! Página não encontrada
              </h1>

              <p className="text-muted fs-6 lh-base mb-4 d-none d-md-block col-lg-11">
                A página que você está procurando não existe ou foi movida. Que tal usar a busca abaixo para localizar o imóvel pelo código ou explorar nossas categorias?
              </p>
              <p className="text-muted fs-6 lh-base mb-4 d-block d-md-none">
                O imóvel que você procura pode ter sido vendido ou o código está incorreto. Não se preocupe, estamos aqui para ajudar você a encontrar o seu próximo lar.
              </p>

              <div className="mb-4 col-md-10 col-lg-11">
                <label className="form-label small fw-semibold text-muted d-block d-md-none mb-2">Já tem o código do imóvel?</label>
                <form onSubmit={handleSearchSubmit} className="input-group shadow-sm rounded-3 overflow-hidden border">
                  <span className="input-group-text bg-white border-0 text-muted ps-3 d-none d-md-block">
                    <i className="fas fa-map-pin"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control border-0 py-2 ps-3 ps-md-2"
                    placeholder="Digite o código do imóvel (ex: IM-9872)..."
                    value={propertyCode}
                    onChange={(e) => setPropertyCode(e.target.value)}
                  />
                  <button type="submit" className="btn text-white px-4 fw-semibold" style={{ backgroundColor: '#0B2545' }}>
                    <span className="d-none d-md-inline">Buscar</span>
                    <i className="fas fa-search d-inline d-md-none"></i>
                  </button>
                </form>
              </div>

              <div className="d-flex flex-column gap-2 d-md-none mb-4 col-sm-8">
                <a href="/" className="btn text-white py-2 fw-semibold rounded-2 d-flex align-items-center justify-content-center gap-2 shadow-sm" style={{ backgroundColor: '#0B2545' }}>
                  <i className="fas fa-home"></i> Voltar para o Início
                </a>
                <a href="/imoveis/casas" className="btn btn-white bg-white border text-dark py-2 fw-semibold rounded-2 shadow-sm">
                  Ver todos os imóveis
                </a>
              </div>

              <div className="mt-4 pt-2">
                <h5 className="fw-bold h6 mb-3 text-uppercase text-muted d-block d-md-none">Navegue pelas nossas categorias:</h5>
                <div className="row g-3 row-cols-2 row-cols-md-2 row-cols-lg-2 col-lg-11">
                  {CATEGORIES.map((cat) => (
                    <div key={cat.id} className="col">
                      <a href={`/imoveis/${cat.id}`} className="card h-100 text-decoration-none bg-white border rounded-3 p-3 d-flex flex-row flex-md-column align-items-center justify-content-start text-start text-md-center gap-3">
                        <div className="rounded-circle p-2 d-flex align-items-center justify-content-center bg-light" style={{ width: '42px', height: '42px', color: '#0B2545' }}>
                          <i className={`${cat.icon} fs-5`}></i>
                        </div>
                        <span className="fw-semibold text-dark small">{cat.name}</span>
                      </a>
                    </div>
                  ))}

                  <div className="col d-none d-md-block">
                    <a href="/" className="card h-100 text-white text-decoration-none rounded-3 p-3 d-flex flex-column align-items-center justify-content-center text-center gap-2" style={{ backgroundColor: '#0B2545' }}>
                      <i className="fas fa-arrow-left fs-5 mb-1"></i>
                      <span className="fw-semibold small">Ir para Início</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6 position-relative mb-4 mb-lg-0">
              <div className="shadow-lg rounded-4 overflow-hidden w-100 border img-rotate">
                <img
                  src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=800&auto=format&fit=crop"
                  alt="Imóvel de alto padrão"
                  className="w-100 h-100"
                  style={{ objectFit: 'cover', minHeight: '280px', maxHeight: '480px' }}
                />
              </div>

              <div className="position-absolute bottom-0 start-0 m-3 m-lg-4 p-3 p-lg-4 bg-white rounded-3 shadow border text-start badge-float">
                <div className="d-flex align-items-center gap-2 text-success mb-2 small fw-bold">
                  <i className="fas fa-check-circle"></i> Consultoria Mendicino
                </div>
                <p className="text-muted m-0 small lh-base fw-medium">Ajudamos você a encontrar o lar ideal de forma ágil e segura.</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
